"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContextServiceFactory = void 0;
const user_context_service_1 = require("./user-context-service");
const cookie_token_provider_1 = require("./cookie-token-provider");
const constants_1 = require("./constants");
class UserContextServiceFactory {
    static initialize(userContextOptions) {
        if (window.userContextService) {
            return;
        }
        window.userContextService = UserContextServiceFactory.create(userContextOptions);
    }
    static create(userContextOptions) {
        userContextOptions || (userContextOptions = {});
        userContextOptions.tokenProvider || (userContextOptions.tokenProvider = new cookie_token_provider_1.CookieTokenProvider(constants_1.TOKEN_API_KEY));
        return new user_context_service_1.UserContextService(userContextOptions);
    }
}
exports.UserContextServiceFactory = UserContextServiceFactory;
